<div class="page-header">
  <h1 class="page-title">Översikt kampanjer</h1>
  <mat-divider></mat-divider>
</div>

<div class="mat-elevation-z3">
  <flow-campaign-calendar [campaignSlots]="campaignSlots">
  </flow-campaign-calendar>
</div>
